import { render, staticRenderFns } from "./detail--attachment.vue?vue&type=template&id=217cf531&"
import script from "./detail--attachment.vue?vue&type=script&lang=js&"
export * from "./detail--attachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports